export enum AssetTypeModel {
    ALL = 1,
    BUILDING = 2,
    GENERALEXPENSE = 3,
    OPERATION = 4,
    RESIDENCE = 5,
    COMPANY = 6,
}
